import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import Stack from "@mui/material/Stack";
const ListInfos = (props) => {
    const { id, dynamicList = [] } = props;
    return (_jsx(Stack, { component: "ul", useFlexGap: true, sx: {
            width: "fit-content",
            listStyle: "none",
            p: 0,
            m: 0,
            gap: { xs: 2, md: 3 },
            "& li": {
                display: "flex",
                alignItems: "flex-start",
                gap: "10px",
                "&::before": {
                    content: '""',
                    flexShrink: 0,
                    width: "10px",
                    height: "10px",
                    backgroundColor: "#0000FF",
                    mt: "6px",
                },
            },
        }, children: dynamicList.map((item, index) => (_jsx("li", { children: _jsxs(Stack, { gap: 0.5, children: [_jsx(Typography, { variant: "subtitle1", component: "p", children: item.label }), _jsx(Typography, { variant: "body2", children: item.description })] }) }, `${index}-${item.label}`))) }, id));
};
export default ListInfos;
